import { useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import { useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import api from '../../api'
import { useAsync } from '../../hooks'
import { PageHeader } from '../Common'
import Loading from '../Loading'
import { updatePreAuthorization } from '../../redux/slices/pre-authorizations'
import { toPath } from '../../routes'
import PreAuthorizationForm from './Form'

export default function EditPreAuthorization() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const getPreAuthorization = useCallback(
    () => api.preAuthorizations.get(id),
    [id],
  )
  const { pending, value } = useAsync(getPreAuthorization)
  const preAuthorization = useMemo(
    () => value && { ...value, billingDate: dayjs(value.billingDate) },
    [value],
  ) // DatePicker in PreAuthorizationForm receives a dayjs object

  const onSubmit = useCallback(
    async (
      {
        cptCode,
        icd10Code,
        billingDate,
        authorized,
        medicalProviderId,
        insuranceAuthorizationNumber,
        notes,
      },
      { setErrors },
    ) => {
      try {
        await dispatch(
          updatePreAuthorization(id, {
            cptCode,
            icd_10_code: icd10Code, // icd10Code is transformed to icd10_code
            billingDate: billingDate.format('YYYY-MM-DD'),
            authorized,
            medicalProviderId,
            insuranceAuthorizationNumber,
            notes,
          }),
        )
        message.success('Remote authorization successfully updated')
        navigate(toPath.preAuthorizations.preAuthorization({ id }))
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, fieldErrors => fieldErrors[0]))
        } else {
          message.error('Oops, we had a problem. Please try submitting again')
        }
      }
    },
    [dispatch, id, navigate],
  )

  if (pending) return <Loading large />

  return (
    <div>
      <PageHeader
        title="Edit Remote Authorization"
        onBack={() => navigate(-1)}
      />
      <PreAuthorizationForm
        onSubmit={onSubmit}
        preAuthorization={preAuthorization}
      />
    </div>
  )
}
